<template>
    <div style="min-height: 600px;">
        <!-- <div class="ueditor">
            <VueMarkdown
            class="markdown-body" style="padding: 20px; z-index: 10;"
            :source="content"
            :breaks="true" :typographer="true" :linkify="true" :highlight="false"
            >
            </VueMarkdown>
        </div> -->
            
        <!-- <div class="ueditor">
            <mavon-editor class="markdown-body" style="padding: 20px;" codeStyle="monokai" v-html="test_html"></mavon-editor>
            <br>
        </div> -->
        
        <div class="container">
            <div class="row">
                <div class="col-10"></div>
                <div class="col-1"><el-button type="primary" icon="el-icon-edit" @click="CreateNotes">写题解</el-button></div>
            </div>
        </div>
        <div class="container" v-loading="loading">
            <el-divider/>
            <div v-for="list in showList" :key="list.id">
                <div class="row ">
                    <div class="col-1">
                        <img :src="list.photo" alt="" width="50px" height="50px" style="border-radius: 50%;">
                    </div>
                    <div class="col-1" style="font-size: 16px; color: rgb(99, 89, 89);">
                        {{ list.goods }}
                        <br>
                        赞
                    </div>
                    <div class="col-6">
                        <el-link :underline="false" @click="ClickMeToShowNotes(list)" style="font-size: 19px; color:#79BBFF;">
                            {{ list.title }}
                            <i class="el-icon-view el-icon--right"></i> 
                        </el-link>
                    </div>
                    <div class="col-4" style="font-size: 14px; ">
                        <div style="float: right;">
                            创建于
                            {{ list.createtime }}
                        </div>
                        <div style="color: #79BBFF; float: right;">{{ list.name.substr(0,7) }}&nbsp;</div>
                        
                    </div>
                </div>
                <el-divider/>
            </div>
        </div>
        <!-- 分页设置 -->
        <div class="block" style="float: right;">
            <!-- :page-size="100" 表示一页100条消息，上限1000条 所以说想自定义上限可以 ==> 想要的页数k  :page-size="(1000 + k - 1) / k"-->
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="pageSize" 
            layout="prev, pager, next, jumper"
            :total="1000">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    // import VueMarkdown from 'vue-markdown'
    import $ from 'jquery'
    export default {
        name:'Solve',
        components: {
            // VueMarkdown,
        },
        data() {
            return {
                list:[],

                pageSize:1, // 页数 = [ 1000 / pageSize ] 
                currentPage3: 1, // 默认位置页
                showList:[],
                loading:true,
            }
        },
        created() {
            const store = this.$store
            const vue = this
            const route = this.$route
            
            $.ajax({ //就算是获取题解不需要登录
                url: 'https://app6132.acapp.acwing.com.cn/api/notes/getlist/',
                type: "post",
                headers: {
                    Authorization: "Bearer " + store.state.me.token,
                },
                data: {
                    pbid: route.params.id,
                },
                success(resp) {
                    if (resp.error_message === 'success') {
                        // console.log("获取题解信息成功咯")
                        vue.list = JSON.parse(resp.list)
                        const s = (vue.list.length) / 10 // 找到自己想要的页数
                        vue.pageSize = 1000 / s;
                        // console.log("list ==>", vue.list, vue.pageSize)

                        /* 完成分页 */
                        vue.showList.length = 0
                        vue.showList = vue.list.slice(0, Math.min(10, vue.list.length))
                        vue.loading = false // 然后结束加载
                    } else {
                        console.log("获取题解信息失败了，原因是 ==> ", resp.error_message)
                    }
                },
                error(resp) {
                    console.log("或许题解彻底失败了，原因是 ==> ", resp)
                }
            })
        },
        methods:{
            ClickMeToShowNotes(list) {
                console.log("list ==> ", list)
                this.$router.push({
                    name:"ShowNotes",
                    params: {
                        id: list.id
                    }
                })
            },
            CreateNotes() { // 打开写题解的markdown页面
                console.log("123")
                this.$router.push({
                    name:'MakeNotes',
                    params: {
                        id: this.$route.params.id,
                    }
                });
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.loading = true // 换页的时候就加载一下
                setTimeout(() => { // 故意等半秒 保证数据一定能加载完
                    this.showList.length = 0
                    this.showList = this.list.slice((val - 1) * 10, Math.min(val * 10, this.list.length))
                    this.loading = false // 然后结束加载
                }, 500);
            }
        },
    }
</script>

<style scoped>

</style>